<div mat-dialog-title class="header-title flex">
  <div class="title">
    <img src="/images/icons/cookie.svg" alt="" />
    <p>Your Privacy is Important</p>
  </div>
  <button type="button" matButton mat-dialog-close (click)="closeDialog()">
    <img
      src="/images/icons/close-icon.svg"
      alt="close cookie settings dialog"
    />
  </button>
</div>
<mat-dialog-content class="dialog-container">
  <div class="dialog-main">
    <p class="dialog-main-text cookie-desc">
      We use cookies that ensure a reliable, personalized and safe shopping
      experience. When you ‘Accept all cookies’ you consent to kingift using
      cookies to personalize your experience. To learn more, see our
      <a [routerLink]="['/pages', 'cookie-policy']">Cookie Notice</a>
      &
      <a [routerLink]="['/pages', 'privacy-policy']">Privacy Statement</a>
    </p>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="cookie-button-container flex">
  <button matButton mat-dialog-close class="flat-button" (click)="openSettings()">Cookie Settings</button>
  <button matButton class="accept-button button outline-button" (click)="acceptAll()">
    Accept All
  </button>
</mat-dialog-actions>

<ng-template #customSettings>
  <div class="settings-dialog-container">
    <h2 mat-dialog-title class="cookie-settings-header w-full">Cookie Settings</h2>
    <hr class="custom-hr" />
    <mat-dialog-content class="settings-detail w-full flex">
      <div class="settings-info flex">
        <p class="settings-message">
          We Use Cookies that Ensure a Reliable, Personalized and Safe Shopping
          Experience.
        </p>
        <mat-accordion>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                Strictly&nbsp;Necessary&nbsp;Cookies
              </mat-panel-title>
              <mat-panel-description>
                <span class="spacer"></span>
                <mat-slide-toggle
                  color="success"
                  checked="true"
                  disabled="true"
                ></mat-slide-toggle>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <p class="settings-description">
              These cookies are necessary for the website to function and cannot
              be switched off
            </p>
          </mat-expansion-panel>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title> Analytics&nbsp;cookies </mat-panel-title>
              <mat-panel-description>
                <span class="spacer"></span>
                <mat-slide-toggle
                  (click)="$event.stopPropagation()"
                  (change)="toggleCookie()"
                  [checked]="analyticsCookie"
                  color="success"
                ></mat-slide-toggle>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <p class="settings-description">
              These cookies collect information that is used either in aggregate
              form to help us understand how our websites are being used or how
              effective our marketing campaigns are.
            </p>
          </mat-expansion-panel>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title> Advertisement&nbsp;cookies </mat-panel-title>
              <mat-panel-description>
                <span class="spacer"></span>
                <mat-slide-toggle
                  color="success"
                  (click)="$event.stopPropagation()"
                  (change)="toggleAds()"
                  [checked]="adsCookie"
                ></mat-slide-toggle>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <!-- <p class="settings-desription">These cookies collect information that is used either in aggregate form to help us understand how our websites are being used or how effective our marketing campaigns are.</p> -->
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="settings-actions flex w-full">
      <button matButton mat-dialog-close class="cancel-button" type="button" (click)="closeAllDialogs()">Cancel</button>
      <button matButton class="button primary-button w-full" (click)="confirmCustom()">
        Confirm My Choices
      </button>
    </mat-dialog-actions>
  </div>
</ng-template>
